import { toLocalYMD } from '../../utils/dateUtils';

const YONA_BRAND_MARK = `${process.env.PUBLIC_URL || ''}/brand/yona-bear-2.png`;

export const NO_FAVORITE_STAND_QUOTES = [
  {
    quote: 'No favorite stand yet? The bucks filed that under “noted” and moved on.',
    caption: 'Set your primary stand in Profile — Yona’s got a thermos ready.',
  },
  {
    quote: 'Every tree looks promising until you realize you forgot to pick one.',
    caption: 'Choose a primary hunting location and we’ll watch the weather for you.',
  },
  {
    quote: 'The wind doesn’t care where you sit, but your knees might.',
    caption: 'Pin a favorite stand so forecast scores know where to find you.',
  },
];

export function getYonaBrandMarkSrc() {
  return YONA_BRAND_MARK;
}

/** Hunt score band label for dashboard display. */
export function getHuntScoreLabel(score) {
  const n = Number(score);
  if (!Number.isFinite(n)) return { label: '—', tone: 'muted' };
  if (n >= 75) return { label: 'EXCELLENT', tone: 'good' };
  if (n >= 60) return { label: 'GOOD', tone: 'good' };
  if (n >= 40) return { label: 'FAIR', tone: 'fair' };
  return { label: 'TOUGH', tone: 'poor' };
}

export function coordsFromGeojson(geojson) {
  const coords = geojson?.coordinates;
  if (!Array.isArray(coords) || coords.length < 2) return null;
  const [lng, lat] = coords;
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  return { lat, lng };
}

/** Pick today's optimal-day entry (API may sort by score, not date). */
export function pickTodayOptimalDay(days) {
  const today = toLocalYMD(new Date());
  const list = Array.isArray(days) ? days : [];
  return list.find((d) => toLocalYMD(d?.date) === today) || list[0] || null;
}

/** Short factor lines for the forecast column (mockup-style). */
export function buildForecastFactorBullets(day) {
  if (!day) return [];
  const factors = day.factors || {};
  const w = day.weather || {};
  const bullets = [];

  const pressurePts = Number(factors.pressure);
  if (Number.isFinite(pressurePts)) {
    bullets.push({
      sign: pressurePts >= 50 ? '+' : '-',
      text: pressurePts >= 50 ? 'Pressure shifting' : 'Stable pressure',
    });
  }

  const wind = typeof w.wind_speed === 'number' ? Math.round(w.wind_speed) : null;
  if (wind != null) {
    const windPts = Number(factors.wind);
    bullets.push({
      sign: Number.isFinite(windPts) && windPts >= 50 ? '+' : '-',
      text: `Wind ${wind} mph`,
    });
  }

  if (day.lunar_phase) {
    const lunarPts = Number(factors.lunar);
    bullets.push({
      sign: Number.isFinite(lunarPts) && lunarPts >= 50 ? '+' : '-',
      text: day.lunar_phase,
    });
  }

  return bullets.slice(0, 3);
}

export function pickNoStandQuote(seed = 0) {
  const list = NO_FAVORITE_STAND_QUOTES;
  const idx = Math.abs(Number(seed) || 0) % list.length;
  return list[idx];
}
